import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { useQuery } from '@apollo/client';

import Source from '../Source/Source';
import css from './LatestNews.module.css';
import useNavigation from '../../hooks/useNavigation';
import GET_LATEST_EVENTS from '../../../queries/getLatestEvents';

const MAX_LENGTH_TITLE = 68;

const formatTitle = (title) => {
  if (title.length < MAX_LENGTH_TITLE) return title;

  return title.substring(0, MAX_LENGTH_TITLE) + '...';
};

function LatestNews() {
  const { toggleEventDossier } = useNavigation();
  const { data } = useQuery(GET_LATEST_EVENTS, {
    fetchPolicy: 'cache-first',
    variables: { limit: 100, filter: 'event' },
  });

  const events = useMemo(() => {
    const list = data?.getFeed?.updates;
    if (!list) return null;

    return list.map((event) => ({ ...event, title: formatTitle(event.title) }));
  });

  const openEntityDossier = useCallback((id) => {
    toggleEventDossier(id);
  }, []);

  if (!events || events.length === 0) return null;

  return (
    <div className={css.main}>
      <div className={css.header}>
        <div className={css.line} />
        <div data-cy="home-news">LATEST NEWS</div>
        <div className={css.line} />
      </div>

      <Caroussel events={events} openEntityDossier={openEntityDossier} />
    </div>
  );
}

export default LatestNews;

function Caroussel({ events, openEntityDossier }) {
  return (
    <div className={css.carrousel}>
      <div className={css.tracker} data-cy="home-events">
        {events.map((event) => (
          <div className={css.eventCard}>
            <h3
              data-cy="home-event-title"
              className={css.eventTitle}
              onClick={() => openEntityDossier(event.id)}
            >
              {event.title}
            </h3>
            {event.sources && (
              <Source data-cy="home-event-source" src={event.sources[0]} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
